import { INameId } from '@modeso/types__aumico-lib-core-be';
import { SortedTemplateItem } from '@modeso/types__aumico-lib-templates-be';
import { ITemplatesSubtotalFormResult } from './templates-subtotal-form-result.interface';

export interface ITemplatesSubtotalFormData {
    languages: string[];
    scopeOptions: INameId[];
    positionOptions: INameId[];
    savedSubtotal?: ITemplatesSubtotalFormResult;
    allItemsInGroup: SortedTemplateItem[];
}
